import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function BranchesPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name:"", code:"", address:"", phone:"" });
  const load = async () => setItems((await api.get("/branches")).data);
  useEffect(()=>{load()},[]);
  const create = async (e) => {
    e.preventDefault();
    await api.post("/branches", form);
    setOpen(false); toast.success("Branch created"); load();
  };
  return (
    <div>
      <PageHeader title="Branches" subtitle="Multi-location management"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary" data-testid="add-branch-btn">+ New branch</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Add branch</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input required placeholder="Branch name" data-testid="branch-name-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <input required placeholder="Code" data-testid="branch-code-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.code} onChange={e=>setForm({...form, code:e.target.value})}/>
                  <input placeholder="Phone" data-testid="branch-phone-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}/>
                </div>
                <textarea placeholder="Address" data-testid="branch-address-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.address} onChange={e=>setForm({...form, address:e.target.value})}/>
                <DialogFooter><button className="btn-primary" data-testid="branch-save-btn">Save</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(b => (
          <div key={b.id} className="linkedin-card p-5 hover:border-[#0A66C2]" data-testid={`branch-card-${b.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-md bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center"><Building2 size={20}/></div>
              <div>
                <div className="font-semibold text-[#000000E6]">{b.name}</div>
                <div className="text-[11px] text-[#00000099] uppercase tracking-wider">{b.code}</div>
              </div>
            </div>
            <div className="mt-3 text-sm text-[#00000099]">{b.address}</div>
            <div className="mt-1 text-sm text-[#00000099]">{b.phone}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
